export const T = {
  en_GB: {
    editManualFee: "Edit Manual Fee",
    addManualFee: "Add Manual Fee",
    editDescription: "Update the manual fee settings.",
    createDescription:
      "A flat percentage fee (optionally with a minimum amount), entered manually.",
    name: "Name",
    namePlaceholder: "e.g., Brokerage, Platform fee",
    nameRequired: "Name is required",
    whenToApply: "When to Apply",
    categoryRecurring: "Manual Recurring",
    categoryDeposit: "Manual Deposit",
    categoryWithdrawal: "Manual Withdrawal",
    categoryRecurringDesc: "Ongoing fee charged periodically as a percentage of value",
    categoryDepositDesc: "Fee charged when depositing (e.g., purchase commission)",
    categoryWithdrawalDesc: "Fee charged when withdrawing (e.g., sale commission)",
    percentage: "Percentage",
    percentageRequired: "Percentage is required and must be greater than 0",
    percentagePlaceholder: "e.g., 0.05",
    minFee: "Minimum fee (amount)",
    minFeeOptional: "Optional",
    minFeePlaceholder: "e.g., 79",
    minFeeHint: "Minimum charged per deposit/withdrawal when the percentage is lower.",
    mapping: "Applies to (optional)",
    mappingHint:
      "Leave as “Any” to apply to all. Otherwise the fee only applies when both match the client and product.",
    clientCategory: "Client cost category",
    productClass: "Product cost class",
    any: "Any",
    cancel: "Cancel",
    save: "Save",
    invalidPercentage: "Percentage must be greater than 0 and at most 100",
    invalidMinFee: "Minimum fee must be 0 or greater",
    failedToSave: "Failed to save manual fee",
  },
  nb_NO: {
    editManualFee: "Rediger manuell kostnad",
    addManualFee: "Legg til manuell kostnad",
    editDescription: "Oppdater innstillingene for den manuelle kostnaden.",
    createDescription: "En fast prosentavgift (eventuelt med et minimumsbeløp), lagt inn manuelt.",
    name: "Navn",
    namePlaceholder: "f.eks. Kurtasje, Plattformavgift",
    nameRequired: "Navn er påkrevd",
    whenToApply: "Når skal den gjelde",
    categoryRecurring: "Manuell løpende",
    categoryDeposit: "Manuelt innskudd",
    categoryWithdrawal: "Manuelt uttak",
    categoryRecurringDesc: "Løpende avgift som belastes periodisk som en prosent av verdien",
    categoryDepositDesc: "Avgift som belastes ved innskudd (f.eks. kjøpskurtasje)",
    categoryWithdrawalDesc: "Avgift som belastes ved uttak (f.eks. salgskurtasje)",
    percentage: "Prosent",
    percentageRequired: "Prosent er påkrevd og må være større enn 0",
    percentagePlaceholder: "f.eks. 0,05",
    minFee: "Minimumsavgift (beløp)",
    minFeeOptional: "Valgfritt",
    minFeePlaceholder: "f.eks. 79",
    minFeeHint: "Minimum som belastes per innskudd/uttak når prosenten er lavere.",
    mapping: "Gjelder for (valgfritt)",
    mappingHint:
      "La stå som «Alle» for å gjelde alt. Ellers gjelder avgiften kun når både kunde og produkt samsvarer.",
    clientCategory: "Kundekostnadskategori",
    productClass: "Produktkostnadsklasse",
    any: "Alle",
    cancel: "Avbryt",
    save: "Lagre",
    invalidPercentage: "Prosent må være større enn 0 og høyst 100",
    invalidMinFee: "Minimumsavgift må være 0 eller større",
    failedToSave: "Kunne ikke lagre manuell kostnad",
  },
} as const;
